import styled from "styled-components";

export const ContainerPrivacyPolicy = styled.div`
  margin: auto;
  color: white;
  background-color: black;
  width: 80%;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const ContainerRight = styled.div``;
